"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(classes, suffix) {
  return classes ? classes.split(' ').map(function (c) {
    return "".concat(c, "-").concat(suffix);
  }).join(' ') : '';
};

exports["default"] = _default;
module.exports = exports.default;